import React, { useContext, useMemo } from 'react';
import * as PropTypes from 'prop-types';

import pluralize from 'ati-utils/pluralize';
import MoreBtn from 'ati-ui-react/components/MoreBtn';
import { interpolate } from 'as-ui-kit/utils/strings';

import { LocaleContext } from 'contexts';
import styles from './styles.modules.scss';
import i18nStrings from './strings';
import { useLocalized } from 'utils/useLocalized';

const MoreButton = ({count, needPay, onClick}) => {
    const strings = useLocalized(i18nStrings);
    const locale = useContext(LocaleContext);
    const companiesPluralized = useMemo(() => pluralize({
        zero: strings.companies.zero,
        one: strings.companies.one,
        few: strings.companies.few,
        many: strings.companies.many,
        other: strings.companies.other,
    }, count, locale), [strings, locale, count]);

    return (
        <div className={styles['more']}>
            <MoreBtn action={onClick}>
                {needPay ? `${strings.needPayTitle}` : `${interpolate(strings.payedTitle, { count: count })} ${companiesPluralized}`}
            </MoreBtn>
        </div>
    );
};

export default MoreButton;

MoreButton.propTypes = {
    count: PropTypes.number,
    needPay: PropTypes.bool,
    onClick: PropTypes.func
};
